<template>
    <div class="!rounded-xl shadow-xl md:shadow-none hover:shadow-xl relative w-full h-full flex flex-col">
        <div class="relative">
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:gdc='https://gambling.com' xml:space='preserve' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' clip-rule='evenodd' viewBox='0 0 423 237'%3E%3Cpath fill='%23efefef' d='M0 0h423v237H0V0Z'/%3E%3Cg gdc:layerName='l1'%3E%3Cpath gdc:layerName='path' fill='%236d7580' d='M223 105a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm-35 28v-2l16-26a3 3 0 0 1 5 0l9 15 4-5 1-1 2 1 10 16a5 5 0 0 1-4 7h-39c-3 0-4-2-4-5Z'/%3E%3C/g%3E%3C/svg%3E"
                 :data-src="article.img_thumb"
                 :alt="article.title"
                 class="lazyload rounded-[10px] !w-full object-cover aspect-article-thumb"/>

            <img :data-src="article.feature_label_img"
                 :alt="article.label_type"
                 v-if="article.label_type !== undefined"
                 class="lazyload absolute left-2.5 top-2.5 z-10"/>

            <div v-if="article.image_credits"
                 class="bg-gdc-gray-900 rounded-[10px] text-white text-xs px-2 py-1 absolute right-1 bottom-1">
                &copy; {{ article.image_credits }}
            </div>
        </div>
        <div class="w-full p-2 flex flex-row justify-between items-center text-xs">
            <div class="flex flex-row">
                <a v-if="article.author_profile_link"
                   :href="article.author_profile_link"
                   :title="article.author_name"
                   class="text-gdc-blue-600 hover:underline flex inline-flex items-center relative z-[1]">
                    <img
                        :data-src="article.author_image"
                        :alt="article.author_name"
                        class="lazyload mr-1"
                        width="30" height="30"/>
                    {{ article.author_name }}
                </a>
                <span v-else class="text-gdc-gray-900 flex inline-flex items-center">
                    <img
                        :data-src="article.author_image"
                        :alt="article.author_name"
                        class="lazyload mr-1"
                        width="30" height="30"/>
                    {{ article.author_name }}
                </span>
            </div>
            <div class="flex flex-row">
                {{ article.reading_time }}
            </div>
        </div>
        <a :href="article.path"
           :title="article.title"
           class="px-2 flex flex-row w-full after:absolute after:inset-0 text-gdc-gray-900 text-lg">
            {{ article.title }}
        </a>
        <p class="px-2 w-full flex flex-row text-gdc-gray-700 text-base leading-6">
            {{ article.short_description }}
        </p>
    </div>
</template>
<script type="text/javascript">
export default
{
    name: "ArticleCard",
    props: {
        article: Object,
    },
};
</script>
